import React, { memo } from 'react';
import moment from 'moment';
import DetailsIcon from '@mui/icons-material/MoreVert';
import StatusBadge from '../StatusBadge/StatusBadge';

export const TaskTypeCell = memo(({ type = '' }) => {
  if (!type) return null;

  return <span className="task-type">{type}</span>;
});

export const ExecutionStatusCell = memo(({ status = '', onStepsClick = null }) => {
  if (!status) return null;

  const getStatusClassName = (status) => {
    const statusMap = {
      Succeeded: 'status-succeeded',
      Failed: 'status-failed',
      Canceled: 'status-canceled',
      Rejected: 'status-rejected',
      Queued: 'status-queued',
      'In progress': 'status-in-progress',
      Removed: 'status-removed',
      'Timed out': 'status-timed-out',
    };
    return statusMap[status] || 'status-unknown';
  };

  const handleClick = (e) => {
    e.stopPropagation();
    if (onStepsClick) {
      onStepsClick();
    }
  };

  return <StatusBadge status={status} statusClassName={getStatusClassName(status)} onClick={handleClick} ariaLabel="View task steps" />;
});

export const TaskIdCell = memo(({ value, onDetailsClick = null }) => {
  const handleClick = (e) => {
    e.stopPropagation();
    if (onDetailsClick) {
      onDetailsClick();
    }
  };

  const handleKeyDown = (e) => {
    if ((e.key === 'Enter' || e.key === ' ') && onDetailsClick) {
      e.preventDefault();
      e.stopPropagation();
      onDetailsClick();
    }
  };

  return (
    <span
      className="link"
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      role="button"
      tabIndex={0}
      title={value}
      aria-label="View task definition"
    >
      {value}
    </span>
  );
});

export const DateCell = memo(({ timestamp = '' }) => {
  if (!timestamp) {
    return <span className="unassigned">N/A</span>;
  }

  return <span>{moment.utc(timestamp).format('MMM D, YYYY')}</span>;
});
